import { roomActionTypes } from './room.types';

// Carrega viewedRooms do localStorage se existir
const loadViewedRoomsFromStorage = () => {
  try {
    const stored = localStorage.getItem('quickAccessViewedRooms');
    if (stored) {
      const parsed = JSON.parse(stored);
      // SEGURANÇA: Garante que é um array válido, não uma função ou outro tipo
      if (Array.isArray(parsed)) {
        return parsed;
      } else {
        // Se não for array, limpa o localStorage e retorna array vazio
        console.warn('viewedRooms no localStorage não é um array válido. Limpando...');
        localStorage.removeItem('quickAccessViewedRooms');
        return [];
      }
    }
  } catch (error) {
    console.error('Erro ao carregar viewedRooms do localStorage:', error);
    // Em caso de erro, limpa o localStorage
    try {
      localStorage.removeItem('quickAccessViewedRooms');
    } catch (e) {
      // Ignora erro ao limpar
    }
  }
  return [];
};

const INITIAL_STATE = {
    waitingRooms: [],
    inProgressRooms: [],
    historyRooms: [],
    // A sala em que o cliente está digitando agora, ou `false`.
    //
    // Era um booleano, e por isso o aviso "Cliente está digitando ...." saía
    // em TODAS as linhas da lista quando o cliente de UMA conversa escrevia.
    // Quem lê compara com o `room_id` da própria conversa.
    clientMessage: false,
    currentRoomId: null,
    currentRoom: [],
    roomAlert: false,
    // Se a lista de salas em andamento JÁ CHEGOU uma vez do servidor.
    //
    // Existe porque `inProgressRooms: []` é ambíguo: significa tanto "ainda não
    // carregou" quanto "carregou e o operador não tem sala nenhuma". O
    // observador de chats atribuídos precisa distinguir os dois -- ele usava um
    // cronômetro de 4 segundos no lugar disso, e quando a lista chegava depois
    // (o que é o normal: ela só carrega ao entrar na tela de chat) tratava TODAS
    // as salas como recém-atribuídas. Ver `utils/salasRecemAtribuidas`.
    inProgressLoaded: false,
    viewedRooms: loadViewedRoomsFromStorage()
};

const roomReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case roomActionTypes.SET_WAITING_ROOMS:
            return {
                ...state,
                waitingRooms: action.payload
            };

        case roomActionTypes.SET_NEW_INPROGRESS_ROOMS:
            return {
                ...state,
                inProgressRooms: action.payload,
                // Mesmo com lista vazia: "carregou e não tem nenhuma" é uma
                // carga, e o operador que recebe a primeira atribuição depois
                // dela tem de ver a aba piscar.
                inProgressLoaded: true
            };

        case roomActionTypes.REMOVE_INPROGRESS_ROOMS:
            return {
                ...state,
                inProgressRooms: action.payload
            };

        case roomActionTypes.SET_HISTORY_ROOMS:
            return {
                ...state,
                historyRooms: action.payload
            };

        case roomActionTypes.SET_SHOW_SENDING_MESSAGE:
            return {
                ...state,
                clientMessage: action.payload
            };

        case roomActionTypes.SET_CURRENT_ROOMID:
            return {
                ...state,
                currentRoomId: action.payload
            };

        case roomActionTypes.SET_CURRENT_ROOM:
            return {
                ...state,
                currentRoom: action.payload
            };

        case roomActionTypes.SET_ROOM_ALERT:
            return {
                ...state,
                roomAlert: action.payload
            };

        /*
         * `SET_LAST_MESSAGES` saiu (12/10/2026).
         *
         * Guardava a ultima mensagem de cada sala, e seu unico leitor era o
         * relogio de inatividade do `Chat`, que mudou para o servidor
         * (`chat:encerrar-inativos`). Sem leitor virou estado morto -- e caro:
         * `RoomList` conecta a fatia `rooms` inteira, entao cada escrita aqui
         * criava um objeto novo e renderizava a tela do chat de ponta a ponta,
         * uma vez por mensagem e por conversa da lista.
         */

        case roomActionTypes.SET_VIEWED_ROOMS:
            // SEGURANÇA: Garante que o payload é um array válido
            // Se for uma função (erro do commit anterior), ignora e mantém o estado atual
            if (typeof action.payload === 'function') {
                console.warn('SET_VIEWED_ROOMS recebeu uma função em vez de um array. Ignorando...');
                return state;
            }
            
            const validPayload = Array.isArray(action.payload) ? action.payload : [];
            
            // NOTA: A verificação de limite é feita no QuickAccessUnified através do checkLimitBeforeAdd
            // e do onLimitReached. O reducer apenas persiste os dados, não bloqueia adições.
            // Isso evita bloqueios prematuros quando maxItems ainda não foi calculado corretamente.
            
            /*
             * Persiste no localStorage SEM o `__isNew`.
             *
             * Ele marca "chat recém-atribuído que o operador ainda não abriu", e
             * é o que faz a aba piscar. Guardado junto, sobrevivia a recargas,
             * a sessões e a dias: uma conversa nunca aberta POR AQUELA ABA
             * ficava piscando para sempre, mesmo sem nada de novo -- medido na
             * tela em 14/10/2026, e o motivo do pedido "não ficar piscando a
             * todo momento".
             *
             * "Recém-atribuído" é um fato da SESSÃO: ou o operador vê o aviso
             * enquanto está ali, ou o que resta a avisar é mensagem não lida --
             * e essa tem sinal próprio e vivo (`newMessageChats`). A aba
             * continua guardada; o que não volta é o piscar.
             */
            try {
                const semMarcaDeNovo = validPayload.map((sala) => {
                    if (!sala || sala.__isNew !== true) return sala;

                    const { __isNew, ...resto } = sala;

                    return resto;
                });

                localStorage.setItem('quickAccessViewedRooms', JSON.stringify(semMarcaDeNovo));
            } catch (error) {
                console.error('Erro ao salvar viewedRooms no localStorage:', error);
            }
            return {
                ...state,
                viewedRooms: validPayload
            };

        default:
            return state;
    }
};

export default roomReducer;